import React from "react";
import styled from "styled-components";
import { space } from "../common/variables";

interface Props {
    heading: string;
    phone: string;
    openingHoursLabel: string;
    openingHours: string;
    align?: "left" | "center";
    className?: string;
}

const SupportInfo = ({
    heading,
    phone,
    openingHoursLabel,
    openingHours,
    align = "left",
    className,
}: Props) => {
    const phoneHref = `tel:${phone.replace(/[^\d+]/g, "")}`;

    return (
        <Wrapper align={align} className={className}>
            <Heading>{heading}</Heading>
            <PhoneRow>
                <PhoneLink href={phoneHref}>
                    <strong>{phone}</strong>
                </PhoneLink>
            </PhoneRow>
            <OpeningHours>
                {openingHoursLabel} <strong>{openingHours}</strong>
            </OpeningHours>
        </Wrapper>
    );
};

export default SupportInfo;

const Wrapper = styled.section<{ align: "left" | "center" }>`
    text-align: ${({ align }) => align};
`;

const Heading = styled.p`
    margin: 0;
    font-weight: 600;
`;

const PhoneRow = styled.p`
    margin: ${space.xxSmall} 0 0;
`;

const PhoneLink = styled.a`
    color: inherit;
    display: inline-block;
`;

const OpeningHours = styled.p`
    margin: ${space.small} 0 0;
`;
